import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const croatia: MarketConfiguration = {
  code: MarketEnum.hr,
  label: "Croatia",
  descriptiveLabel: "Croatian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Croatia",
  locale: LocaleEnum.hr,
  serviceLocale: ServiceLocaleEnum.hr,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-hr",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.hr,
  adyenMarket: MarketEnum.hr,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default croatia;
